import styled from 'styled-components';

import device from 'styles/media';

const Heading = styled.h2`
  font-family: Noto Sans;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  color: #000000;
  margin-bottom: 8px;
`;

const SubHeading = styled.p`
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #828282;
  margin-bottom: 20px;
`;

const TabSelection = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 12px;
`;

const EachTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 48px;
  border-radius: 4px;
  width: 180px;
  color: ${(props) => (props.isActive ? '#FFFFFF' : '#078AE2')};
  background-color: ${(props) => (props.isActive ? '#078AE2' : '#FFFFFF')};
  border: 1px solid #078ae2;
  padding: 16px 18px;

  ${device.mediumViewport} {
    width: 140px;
    padding: 12px;
  }
`;

const EachTabLabel = styled.p`
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: ${(props) => (props.isActive ? '#FFFFFF' : '#078AE2')};
`;

const DottedLine = styled.div`
  width: 100%;
  border-top: 1px dashed #acacac;
  margin-top: 24px;
`;

const LanguageSelection = styled.div`
  margin-top: 24px;
`;

const LanguageTabs = styled.div`
  gap: 16px;
`;

const EachLanguageTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 48px;
  border-radius: 4px;
  width: 240px;
  color: ${(props) => (props.isActive ? '#FFFFFF' : '#078AE2')};
  background-color: ${(props) => (props.isActive ? '#078AE2' : '#FFFFFF')};
  border: 1px solid #078ae2;
  padding: 16px 18px;
  text-transform: capitalize;
`;

export {
  Heading,
  SubHeading,
  TabSelection,
  EachTab,
  DottedLine,
  LanguageSelection,
  LanguageTabs,
  EachLanguageTab,
  EachTabLabel,
};
